export enum DeviceJobField {
    ID = "id",
    TRACKING_ID = "trackingId",
    REQUESTED_AT = "requestedAt",
    SOURCE = "source",
    TYPE = "type",
    ORGANIZATION = "organization",
    ENVIRONMENT = "environment",
    VEHICLE = "vehicle",
    DEVICE_ID = "deviceId",
    COMPANY_CARD_NUMBER = "companyCardNumber",
    DRIVER_CARD_NUMBER = "driverCardNumber",
    PERIOD_START = "periodStart",
    PERIOD_END = "periodEnd",
    STATUS = "status",
    RETRIES = "retries",
    USER = "user",
    PRIORITY = "priority",
    COMPLETED_AT = "completedAt",
}

export enum DeviceJobSource {
    CUSTOMER = "CUSTOMER",
    SUPPORT = "SUPPORT",
    CYCLIC = "CYCLIC",
    SYSTEM = "SYSTEM",
}

export enum DeviceJobType {
    AUTHENTICATION = "AUTHENTICATION",
    MASS_STORAGE = "MASS_STORAGE",
    DRIVER_CARD = "DRIVER_CARD",
}

export enum DeviceJobStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "DONE",
    ERROR = "ERROR",
}

export enum DeviceJobPriority {
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
}

export interface DeviceJob {
    [DeviceJobField.ID]: number;
    [DeviceJobField.TRACKING_ID]?: string;
    [DeviceJobField.REQUESTED_AT]: string;
    [DeviceJobField.SOURCE]: DeviceJobSource;
    [DeviceJobField.TYPE]: DeviceJobType;
    [DeviceJobField.ORGANIZATION]?: string;
    [DeviceJobField.ENVIRONMENT]?: string;
    [DeviceJobField.VEHICLE]?: string;
    [DeviceJobField.DEVICE_ID]?: number;
    [DeviceJobField.COMPANY_CARD_NUMBER]?: string;
    [DeviceJobField.DRIVER_CARD_NUMBER]?: string;
    [DeviceJobField.PERIOD_START]: string;
    [DeviceJobField.PERIOD_END]?: string;
    [DeviceJobField.STATUS]: DeviceJobStatus;
    [DeviceJobField.RETRIES]?: number;
    [DeviceJobField.USER]: string;
    [DeviceJobField.PRIORITY]: DeviceJobPriority;
    [DeviceJobField.COMPLETED_AT]?: string;
}
